<template>
  <v-app>
    <v-app-bar app color="primary" dark>
      <h3>Dashboard</h3>

      <v-spacer></v-spacer>
      <v-btn text small @click="$router.push('/contacts')">
        Visualizza Contatti
      </v-btn>
    </v-app-bar>

    <v-main>
      <router-view />
    </v-main>
  </v-app>
</template>

<script>
export default {
  name: "App",
  data: () => ({
    //
  }),
  mounted: () => console.log(process.env.VUE_APP_BACKEND)
};
</script>
